<script>
  // Строка версии и сборки (2026-09-18).
  //
  // Показывает три вещи, которых порознь не хватает при разборе: номер версии
  // (минор = номер этапа из PLAN.md), момент сборки и версию service worker —
  // то есть что реально закэшировано на устройстве. Расхождение последних двух
  // объясняет большинство «странностей» после выкатки на iPhone.
  import { onMount } from 'svelte';
  import { TEXT } from '../ui-text.js';

  // Подставляются на сборке (vite define); в тестах их нет — отсюда fallback.
  const version = typeof __APP_VERSION__ === 'string' ? __APP_VERSION__ : '0.0.0';
  const buildTime = typeof __BUILD_TIME__ === 'string' ? __BUILD_TIME__ : '';

  let swVersion = '';
  let copied = false;
  let copyTimer = null;

  $: buildLabel = formatBuild(buildTime);
  $: stamp = [
    `${TEXT.about.appName} ${version}`,
    buildLabel ? `${TEXT.about.buildPrefix} ${buildLabel}` : '',
    swVersion,
  ].filter(Boolean).join(' · ');

  function formatBuild(iso) {
    if (!iso) {
      return '';
    }
    const date = new Date(iso);
    if (Number.isNaN(date.getTime())) {
      return '';
    }
    return date.toLocaleString('ru-RU', {
      day: '2-digit', month: '2-digit', year: 'numeric', hour: '2-digit', minute: '2-digit',
    });
  }

  async function readServiceWorkerVersion() {
    try {
      const response = await fetch('/sw.js', { cache: 'no-store' });
      if (!response.ok) {
        return '';
      }
      const source = await response.text();
      // sw.template.js: const VERSION = 'a5e439cd8de9'; (имя переменной именно VERSION —
      // на этом уже один раз обожглись: тест проверял выдуманное CACHE_VERSION).
      return source.match(/\bVERSION\s*=\s*['"]([a-f0-9]{6,})['"]/)?.[1] || '';
    } catch (_) {
      // Офлайн или блокировка — строка просто останется без хеша.
      return '';
    }
  }

  async function copyStamp() {
    try {
      await navigator.clipboard.writeText(stamp);
      copied = true;
      clearTimeout(copyTimer);
      copyTimer = setTimeout(() => {
        copied = false;
      }, 2000);
    } catch (_) {
      // Буфер недоступен (не-secure context) — строку можно выделить руками.
    }
  }

  onMount(async () => {
    swVersion = await readServiceWorkerVersion();
    return () => clearTimeout(copyTimer);
  });
</script>

<button type="button" class="build-stamp" on:click={copyStamp} title={TEXT.about.copyHint}>
  {copied ? TEXT.about.copied : stamp}
</button>

<style>
  .build-stamp {
    display: block;
    width: 100%;
    margin: var(--spacing-md) 0 0;
    padding: 0.35rem 0;
    border: none;
    background: none;
    color: var(--text-muted);
    font: inherit;
    font-size: 0.72rem;
    text-align: center;
    cursor: pointer;
    /* Строка служебная: не должна тянуть на себя внимание и ломать вёрстку. */
    overflow-wrap: anywhere;
  }
</style>
